import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { Role } from "./roles";
import { UserRoleService } from "./user-role-service";

@Directive({selector: "[authorizedForRoles]"})
export class AuthorizedForRolesDirective implements OnInit {
    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private userRoleService: UserRoleService) {
    }

    private roles: Role[];

    @Input() set authorizedForRoles(roles: Role[]) {
        this.roles = roles;
    }

    ngOnInit() {
        if (this.userRoleService.hasRoles(this.roles)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
